<template>
<!--  -->
  <div class='detail'>
    <div style='background: #fff; padding: 20px;'>
      <div class="titleMain">
        <span class="titleSpan">{{type == '01' ? '政策法规' : '通知公告'}}</span>
        <Icon type="ios-arrow-forward" />
        <span class="titleName">{{title}}</span>
      </div>
      <div class='content'>
        <h2>{{title}}</h2>
        <div class='text'>
          <div v-html='text'></div>
        </div>
        <div class='remarks' v-show='remarks.length > 0'>
          <p class='label'>附件：</p>
          <p class='file'>
            <upload-tf :isEdit='false' :uploadList='remarks'></upload-tf>
          </p>
        </div>
      </div>
      <div class='foot'>
        {{time}}
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api/homePage.js'
import UploadTf from '@/components/uploadTF.vue'

export default {
  name: '',
  props: {

  },
  data () {
    return {
      title: '',
      remarks: [],
      text: '',
      time: '',
      type: ''
    }
  },
  mixins: [],
  components: {
    UploadTf
  },
  computed: {

  },
  watch: {

  },
  created () {
    const id = this.$route.query.id;
    this.type = this.$route.query.type
    getInfo({id}).then((res) => {
      // console.log(res)
      if (res.status != 200) return
        if(res.data.success) {
          this.remarks = res.data.data.remarks.filter((item) => {
            return item.contentType == '02'
          }) || []
          const { title, content, pubTime } = res.data.data.tbPolicyReleaseInfo
          this.title = title
          this.text = content
          this.time = pubTime
        }
    }).catch(() => {

    })
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.detail {
  min-height: 400px;
  background: #f5f5f5;
  padding: 30px 8%;
  .content {
    h2 {
      text-align: center;
      padding: 20px 40px;
      color: black;
    }
    .text {
      margin: 20px;
      padding: 60px;
      color: #333;
      font-size: 14px;
    }
    .remarks {
      display: flex;
      flex-direction: row;
      margin: 40px 100px;
      .label {
        width: 50px;
        text-align: right;
      }
    }
  }
  .foot {
    height: 24px;
    line-height: 24px;
    text-align: right;
    padding: 0 100px;
  }
  .titleMain {
      height: 40px;
      line-height: 40px;
      .titleSpan {
          font-size: 12px;
          color: gray;
      }
      .titleName {
          font-size: 12px;
      }
  }
}
</style>
